import 'normalize.css/normalize.css';
import './styles/app.scss';
import $ from 'jquery/dist/jquery';
// External libs

// Local scripts
import {
    init,
    selectBlock
} from './scripts/main';


document.addEventListener("DOMContentLoaded", () => {
    init();
});
